import { render } from "./MainProduk.vue?vue&type=template&id=2d5030e9"
import script from "./MainProduk.vue?vue&type=script&lang=js"
export * from "./MainProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__